<template>
  <v-card flat rounded="lg" class="mb-4">
    <v-card-title class="body-1 font-weight-bold">Pedidos realizados offline</v-card-title>
    <v-card-text>
      <v-layout align-center justify-center>
        <v-progress-circular
          indeterminate
          class="mt-2"
          width="2"
          size="40"
          v-if="loading"
        ></v-progress-circular>
        <v-alert v-else-if="pedidos.length == 0" class="body-2"
          ><i>Nenhum pedido encontrado</i></v-alert
        >
        <v-card
          color="grey lighten-4"
          v-for="(ped, i) in pedidos"
          :key="i"
          rounded="lg"
          flat
          width="100%"
        >
          <v-card-text>
            <p class="mb-1">
              Cliente<span class="float-right">{{ ped.cliente.nome }}</span>
            </p>
            <p class="mb-1">
              Tipo Pedido<span class="float-right">{{
                ped.tipopedido.descricao
              }}</span>
            </p>
            <p class="mb-1">
              Emissão<span class="float-right">{{
                formatarData(ped.datahoraemissao)
              }}</span>
            </p>
            <p class="mb-1">
              Validade<span class="float-right">{{
                formatarData(ped.datahoravalidade)
              }}</span>
            </p>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { getPedidosDB } from "@/db/pedidos";
import moment from "moment";
export default {
  data: () => ({
    pedidos: [],
    loading: true,
    headers: [
      { text: "Cliente", value: "cliente.nome" },
      { text: "Tipo Pedido", value: "tipopedido.descricao" },
      { text: "Emissão", value: "datahoraemissao" },
      { text: "Validade", value: "datahoravalidade" },
    ],
  }),
  methods: {
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY LTS");
    },
  },
  async mounted() {
    this.loading = true;
    this.pedidos = await getPedidosDB("pedidos-insumos");
    this.loading = false;
  },
};
</script>

<style>
</style>